import * as Yup from 'yup';
import * as validator from '@rsos/utils/validators';

const NAME_ERROR = 'Must be between 2 and 30 characters';
const EMAIL_ERROR = 'Invalid email';

export const validationSchema = Yup.object().shape({
  first_name: Yup.string()
    .min(2, NAME_ERROR)
    .max(30, NAME_ERROR)
    .required(NAME_ERROR),
  last_name: Yup.string()
    .min(2, NAME_ERROR)
    .max(30, NAME_ERROR)
    .required(NAME_ERROR),
  email: Yup.string().test('isValidEmail', EMAIL_ERROR, function (value) {
    const { path, createError } = this;
    const result = validator.isValidEmail(value)
      ? true
      : createError({ path, message: EMAIL_ERROR });
    return result;
  }),
});
